<template>
  <v-card
    width="100%"
    color="adaprimary"
    class="mb-4"
    :dark="this.$vuetify.theme.dark"
  >
    <v-card-title class="font-weight-black adawhite--text text--lighten-2">
      {{ food.humandate }}
    </v-card-title>
    <v-card-subtitle class="text-h5 font-weight-bold adawhite--text">
      {{ food.data }}
    </v-card-subtitle>

    <v-card-actions></v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    food: {
      type: Object,
      required: true
    }
  }
};
</script>
